import { apiInstance } from "./ApiInstance"

export const getAllCasesCount = async () => {
    let { data = {} } = await apiInstance.get("api/case/case-status");
    return data
}